import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mm-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class MmPageHeaderComponent implements OnInit {

  constructor() {

  }

  ngOnInit() {

  }

}
